<template>
    <div>
        <b-modal
            id="export-process-popup" 
            ref="modal"
            title="Export Process"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            no-close-on-backdrop
            no-close-on-esc
        >
            <p class="m-custom">
                Would you like to download report data in Excel format?
            </p>

            <b-form
                @submit.stop.prevent="exportReport()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <div class="export-radio-section">
                            <div class="icon-section">
                                <div class="excel-icons">
                                    <excel-icon></excel-icon>
                                </div>
                                <!--<div class="pdf-icons">-->
                                    <!--<pdf-icon></pdf-icon>-->
                                <!--</div>-->
                            </div>
                            <div class="export-form-section">
                                <b-form-group class="export-files">
                                    <b-form-radio-group
                                        v-model="exportType"
                                        :options="form.exportType" 
                                        name="export"
                                    ></b-form-radio-group>
                                    <div class="row">
                                        <div class="col-xs-12 col-md-6">
                                            <div
                                                class="
                                                    form-group
                                                    custom-datepicker
                                                "
                                            >
                                                <date-picker
                                                    ref="start date"
                                                    v-model="startDate"
                                                    v-validate="{
                                                        required: true,
                                                        date_format:
                                                            'MM/dd/yyyy',
                                                    }"
                                                    placeholder="Start Date"
                                                    class="form-control"
                                                    name=" start date"
                                                    format="DD/MM/YYYY"
                                                    :class="{
                                                        'is-invalid':
                                                            errors.has(
                                                                'start date'
                                                            ),
                                                    }"
                                                    lang="en"
                                                >
                                                </date-picker>

                                                <i
                                                    :class="[
                                                        {
                                                            'disable-input': false,
                                                        },
                                                        'icon-calendar',
                                                    ]"
                                                ></i>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-6">
                                            <div
                                                class="
                                                    form-group
                                                    custom-datepicker
                                                "
                                            >
                                                <date-picker
                                                    ref="end date"
                                                    v-model="endDate"
                                                    v-validate="{
                                                        required: true,
                                                        date_format:
                                                            'MM/dd/yyyy',
                                                    }"
                                                    placeholder="End Date"
                                                    class="form-control"
                                                    name="end date"
                                                    format="DD/MM/YYYY"
                                                    :class="{
                                                        'is-invalid':
                                                            errors.has(
                                                                'end date'
                                                            ),
                                                    }"
                                                    lang="en"
                                                >
                                                </date-picker>

                                                <i
                                                    :class="[
                                                        {
                                                            'disable-input': false,
                                                        },
                                                        'icon-calendar',
                                                    ]"
                                                ></i>
                                            </div>
                                        </div>
                                    </div>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :class="loading ? 'disabled' : ''"
                        btn-label="Generate"
                        btn-type="submit"
                        btn-variant="primary"
                    ></base-button>
                    <base-button
                        :disabled="loading"
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import excelIcon from '@/components/icons/ExcelIcon.vue'
import pdfIcon from '@/components/icons/PdfIcon.vue'
import XLSX from 'xlsx'
import _ from 'lodash'
import request from '@/utils/request'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'


export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        excelIcon,
        pdfIcon,
        DatePicker
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        exportGraphId: {
            type: String,
            default: null,
        },
        fileName: {
            type: String,
            required: true,
        },
        graphIds: {
            type: Array,
            required: true,
        },
        query:{
            type: Object,
            required: false
        }
 
        
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            startDate: null,
            endDate: null,
            exportType: 'xlsx',
            form: {
                exportType: [
                    {
                        text: 'Export Customers',
                        value: 'exportCustomerDetailsExcel',
                    },
                    // {
                    //     text: 'Export All PDF reports',
                    //     value: 'bulkGeneratePdf',
                    // },
                    // {
                    //     text: 'Export Name Screening Hits Data',
                    //     value: 'bulkFetchNameScreeningPdf',
                    // },
                ],
            },
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'hidePopup',
            'chartsHeadings',
            'dataSegmentId',
            'hasScopes',
        ]),
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async exportReport() {
            try {

                let startDate
                let endDate
                if (this.startDate) {
                    startDate = this.$moment(this.startDate).format(
                        'YYYY-MM-DD'
                    )
                } else {
                    startDate = null
                }

                if (this.endDate) {
                    endDate = this.$moment(this.endDate).format('YYYY-MM-DD')
                } else {
                    endDate = null
                }

                this.query.startDate = startDate
                this.query.endDate = endDate


                if (this.exportType == 'exportCustomerDetailsExcel') {
                    this.exportCustomerDetails()
                } else if (this.exportType == 'bulkFetchNameScreeningPdf') {
                    this.exportBulkFetch()
                }
                else if (this.exportType == 'bulkGeneratePdf') {
                    this.bulkGeneratePdf()
                }
                else
                {
                    this.$store.commit('setError', 'Please select an option first')
                    return false
                }
                this.$store.commit('setLoading', true)

                // if (this.hasScopes('system-logs')) {
                //     await request.post('system-logs/', {
                //         dataSegmentId: this.dataSegmentId,
                //         module: 'insights',
                //         type:
                //             this.exportGraphId == 'stats-charts'
                //                 ? 'export-customer-statistics-' +
                //                   this.exportType
                //                 : 'export-activity-dashboard-' +
                //                   this.exportType,
                //         action:
                //             this.exportGraphId == 'stats-charts'
                //                 ? 'export-customer-statistics-' +
                //                   this.exportType
                //                 : 'export-activity-dashboard-' +
                //                   this.exportType,
                //     })
                // }
            } catch (error) {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', error)
            }
        }, //end of exportReport()

        exportCustomerDetails(){
            axios({
                method: 'post',
                url: `${process.env.VUE_APP_API_URL}customers/export`,
                params: this.query
                // responseType: 'blob',
            })
                .then((response) => {
                    this.$store.commit('setLoading', false)
                    this.onHidden()
                    this.$toasted.show('Export process has been started, you will be notified shortly',{
                        type: 'success',
                        duration: 5000,
                        keepOnHover:true
                    })
                })
                .catch(() => console.log('error occured'))
        },
        exportBulkFetch() {
            axios({
                method: 'get',
                url: `${process.env.VUE_APP_API_URL}customers/generateReport2/${this.dataSegmentId}`,
                // responseType: 'blob',
            })
                .then((response) => {
                    this.$store.commit('setLoading', false)
                    this.onHidden()
                    this.$toasted.show('Export process has been started, you will see your download shortly',{
                        type: 'success',
                        duration: 5000,
                        keepOnHover:true
                    })
                })
                .catch(() => console.log('error occured'))
        },
        bulkGeneratePdf() {
            axios({
                method: 'get',
                url: `${process.env.VUE_APP_API_URL}customers/generate-pdf-bulk/${this.dataSegmentId}`,
                // responseType: 'blob',
            })
                .then((response) => {
                    this.$store.commit('setLoading', false)
                    this.onHidden()
                    this.$toasted.show('Export process has been started, you will see your download shortly',{
                        type: 'success',
                        duration: 5000,
                        keepOnHover:true
                    })
                })
                .catch(() => console.log('error occured'))
        },

        // forceFileDownload(response) {
        //     console.log('This is the response:', response)

        //     const url = window.URL.createObjectURL(new Blob([response.data]))
        //     const link = document.createElement('a')
        //     link.href = url
        //     link.setAttribute('download', 'bulk-fetch-report.pdf')
        //     document.body.appendChild(link)
        //     link.click()
        //     this.$store.commit('setLoading', false)
        //     console.log('Finished everyhting')
        //     this.onHidden()
        // },

    
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Export Activity Timeline
         *
         * @return {void}
         */
       
    },
}
</script>
